import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { getProfileCompaniesSuccessful, getProfileCompaniesFailed } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* getProfileCompanies(action) {
  try {
    const url = `${BACKEND_URL}/profile/companies`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET');
    const data = yield getBodyJson(dataResponse);
    if (dataResponse.status === OK) {
      yield put(getProfileCompaniesSuccessful(data.data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(getProfileCompaniesFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(getProfileCompaniesFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
